import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
export default function BuildingExcellence() {
  return <section data-section-id="256807" id="building-excellence" className="relative min-h-screen flex items-center bg-background overflow-hidden dark text-foreground">
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_austin_home_exterior.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_austin_home_exterior.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/luxury_austin_home_exterior.png-wvc-sizes" alt="Luxury Austin custom home exterior" className="w-full h-full object-cover !bg-[rgba(0,0,0,0.42)]" loading="lazy" />
        <div className="absolute inset-0 !opacity-[0.76] !bg-[rgba(0,0,0,0.41)] !text-[rgba(250,250,250,0.74)]"></div>
        <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-black/40 to-transparent pointer-events-none"></div>
      </div>

      <div className="container relative z-10 px-4 pt-32 pb-24 mx-auto !opacity-[1] !text-[rgba(250,250,250,0.77)] md:px-6">
        <div className="max-w-3xl">
          <h2 className="uppercase tracking-[0.2em] font-default whitespace-normal sm:whitespace-nowrap [text-stroke:1px_#BEB09E] drop-shadow-sm !text-[rgba(255,255,255,1)] !font-extrabold !text-4xl sm:!text-5xl md:!text-6xl ![margin:0px_0px_100px_0px] !p-0">God Father <br />&nbsp; Company</h2>
          
          <div className="flex items-center mb-6">
            <span className="font-default tracking-widest uppercase text-primary-foreground !text-left !font-semibold text-lg sm:text-2xl md:text-3xl lg:text-[35px]">General Contractor</span>
          </div>

          <h1 className="font-bold text-white leading-[1.1] font-default mb-6 tracking-widest uppercase text-2xl sm:text-3xl md:text-4xl lg:text-5xl">Building Excellence<br />Across Texas</h1>

          <p className="text-lg text-white/90 max-w-2xl font-mono mb-10 leading-relaxed tracking-normal !font-extrabold md:text-[20px]">Luxury Custom Homes, Remodeling &amp; New Construction. <br />We bring unparalleled craftsmanship and professional reliability to every project. <br />Proudly Serving Austin, Westlake, Bee Cave, Lakeway and surrounding areas.</p>

          <div className="flex flex-wrap items-center gap-4">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button size="lg" className="px-8 h-12 text-base bg-transparent border border-white text-white hover:bg-white hover:text-black transition-colors duration-300 rounded-md cursor-pointer">
                  Request Estimate
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="start" className="bg-card border-border min-w-[200px] rounded-md">
                <DropdownMenuItem asChild className="cursor-pointer focus:bg-accent focus:text-accent-foreground py-3 px-4">
                  <Link to="mailto:gfcllcs@gmail.com" className="w-full font-mono uppercase tracking-wider text-sm">Email Us</Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild className="cursor-pointer focus:bg-accent focus:text-accent-foreground py-3 px-4 border-t border-border/50">
                  <Link to="sms:512-956-0639" className="w-full font-mono uppercase tracking-wider text-sm">Text Us</Link>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>

            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button size="lg" variant="outline" className="px-8 h-12 text-base border-white text-white hover:bg-white/10 rounded-md cursor-pointer">
                  Call Now
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="start" className="bg-card border-border min-w-[200px] rounded-md">
                <DropdownMenuItem asChild className="cursor-pointer focus:bg-accent focus:text-accent-foreground py-3 px-4">
                  <Link to="tel:512-956-0639" className="w-full font-mono uppercase tracking-wider text-sm">Mobile: 512-956-0639</Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild className="cursor-pointer focus:bg-accent focus:text-accent-foreground py-3 px-4 border-t border-border/50">
                  <Link to="tel:737-376-2987" className="w-full font-mono uppercase tracking-wider text-sm">Office: 737-376-2987</Link>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>

            <Button asChild size="lg" className="px-8 h-12 text-base bg-transparent border border-white text-white hover:bg-white hover:text-black transition-colors duration-300 rounded-md cursor-pointer">
              <Link to="https://book.housecallpro.com/book/God-Father-Company/8e32f7e5d3cf46aea8647b87707dd22a?v2=true" newTab>
                Book Now
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}